import styles from './HotkeysOverlay.module.css'

interface Props {
  open: boolean
  onClose: () => void
}

export function HotkeysOverlay({ open, onClose }: Props) {
  if (!open) return null
  return (
    <div className={styles.wrap} role="dialog" aria-label="Keyboard shortcuts">
      <button type="button" className={styles.close} onClick={onClose} aria-label="Close">
        ×
      </button>
      <h3>Keyboard shortcuts</h3>
      <ul>
        <li><kbd>Space</kbd> / <kbd>K</kbd> Play / Pause</li>
        <li><kbd>←</kbd> <kbd>→</kbd> Seek ±5s</li>
        <li><kbd>J</kbd> <kbd>L</kbd> Seek ±10s</li>
        <li><kbd>↑</kbd> <kbd>↓</kbd> Volume</li>
        <li><kbd>M</kbd> Mute · <kbd>F</kbd> Fullscreen · <kbd>T</kbd> Theater</li>
        <li><kbd>C</kbd> Captions · <kbd>?</kbd> This help</li>
        <li>Double-tap sides (mobile) ±10s</li>
      </ul>
    </div>
  )
}
